<template>
  <div id="DeliveryForm">
    <LogoHeader :shopCode="orderDetail.shopCode" />

    <form>
      <label for="email">Correo electrónico:</label>
      <input type="email" id="email" v-model="orderDetail.email" class="input-text" />

      <label for="name">Nombre y Apellido:</label>
      <input type="text" id="name" v-model="orderDetail.name" class="input-text" />

      <label for="phone">Teléfono de contacto:</label>
      <input type="text" id="phone" v-model="orderDetail.phone" class="input-text" />

      <label for="costCenterNumber">Número centro de costos:</label>
      <input type="text" id="costCenterNumber" v-model="orderDetail.costCenterNumber" class="input-text" />

      <label for="deliveryDate">Fecha de entrega:</label>
      <input type="date" id="deliveryDate" v-model="orderDetail.deliveryDate" class="input-text" />

      <label for="companyName">Nombre de la empresa:</label>
      <input type="text" id="companyName" v-model="orderDetail.companyName" class="input-text" />

      <label for="shippingAddress">Dirección de entrega:</label>
      <input type="text" id="shippingAddress" v-model="orderDetail.shippingAddress" class="input-text" />

      <!-- <label>Lugar de entrega:</label>
      <label
        v-for="(dp, index) in deliveryPlaceList"
        :key="index"
        style="display: inline-flex"
      >
        <input
          :checked="orderDetail.deliveryPlace === dp"
          @change="orderDetail.deliveryPlace = dp"
          type="radio"
        />
        <span class="lever lever-width"></span>
        <div class="place-name">{{ dp }}</div>
      </label> -->

      <Spinner v-if="isLoading" />
      <input v-else type="submit" class="button" value="Enviar" @click.prevent="sendDeliveryForm()" />
    </form>
  </div>
</template>

<script>
import Spinner from "../Components/Spinner";
import LogoHeader from "../Components/LogoHeader";
import { http } from "../axios";
import { baseUrl, mySelfUrl } from "../server";

export default {
  data() {
    return {
      isLoading: false,
      orderDetail: {
        externalReference: null,
        shopCode: null,
        email: "",
        name: "",
        phone: "",
        costCenterNumber: "",
        deliveryDate: "",
        // deliveryPlace: "",
        companyName: "",
        shippingAddress: ""
      },
      // deliveryPlaceList: [
      //   "CASA MATRIZ (Torre Perón) se retira por comedor, 7mo piso.",
      //   "PLAZA (Torre Leiva) se retira por comedor, 4to piso.",
      // ],
    };
  },
  computed: {},
  mounted() {
    this.orderDetail.externalReference = this.$route.query.externalReference;
    this.orderDetail.shopCode = this.$route.query.shop_code;
  },
  methods: {
    sendDeliveryForm() {
      if (this.isRequestValid() == false) return;

      this.isLoading = true;

      http
        .post(`${baseUrl}/api/PaymentConfirmed`, {
          ExternalReference: this.orderDetail.externalReference,
          email: this.orderDetail.email,
          name: this.orderDetail.name,
          phone: this.orderDetail.phone,
          costCenterNumber: this.orderDetail.costCenterNumber,
          deliveryDate: this.orderDetail.deliveryDate,
          // deliveryPlace: this.orderDetail.deliveryPlace,
          companyName: this.orderDetail.companyName,
          shippingAddress: this.orderDetail.shippingAddress,
        })
        .then((response) => {
          console.log(`${JSON.stringify(response)}`);
          if (response.data.responseCode === 0) {
            // this.$store.commit("RESET_STATE");
            this.isLoading = false;
            window.location.href = `${mySelfUrl}/#/Success?c=${this.orderDetail.shopCode}`;
          } else {
            this.isLoading = false;
            alert(
              "No pudimos registrar su pedido. Por favor reintente mas tarde!"
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          alert(
            "No pudimos registrar su pedido. Por favor reintente mas tarde!"
          );
        });
    },
    isRequestValid() {
      if (this.orderDetail.email === "") {
        alert("El correo electrónico es obligatorio!");
        return false;
      }
      if (this.validateEmail(this.orderDetail.email) === false) {
        alert("El correo electrónico es inválido!");
        return false;
      }
      if (this.orderDetail.name === "") {
        alert("El nombre es obligatorio!");
        return false;
      }
      if (this.orderDetail.phone === "") {
        alert("El teléfono es obligatorio!");
        return false;
      }
      if (this.orderDetail.costCenterNumber === "") {
        alert("El número centro de costos es obligatorio!");
        return false;
      }
      if (this.orderDetail.deliveryDate === "") {
        alert("La fecha de entrega es obligatoria!");
        return false;
      }
      if (this.isValidDate(this.orderDetail.deliveryDate) === false) {
        alert("La fecha ingresada no es válida. Debe ser mayor al día actual!");
        return false;
      }
      // if (this.orderDetail.deliveryPlace === "") {
      //   alert("El lugar de entrega es obligatorio!");
      //   return false;
      // }
      if (this.orderDetail.companyName === "") {
        alert("La empresa es obligatoria!");
        return false;
      }
      if (this.orderDetail.shippingAddress === "") {
        alert("La dirección de envío es obligatoria!");
        return false;
      }

      return true;
    },
    validateEmail(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    isValidDate(deliveryDate) {
      const now = new Date();

      deliveryDate = deliveryDate.split("-");
      deliveryDate = new Date(
        deliveryDate[0],
        deliveryDate[1] - 1,
        deliveryDate[2]
      );

      const diffTime = deliveryDate - now;
      if (diffTime <= 0) return false;

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 2) return false;

      return true;
    },
  },
  components: {
    Spinner,
    LogoHeader,
  },
};
</script>
<style scoped>
#DeliveryForm {
  height: 40em;
  padding-bottom: 100vh;
}

#DeliveryForm div {
  margin: 0;
  position: absolute;
  top: 35%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
  text-align: left;
  width: -webkit-fill-available;
  margin-left: 4vh;
}

.input-text {
  width: 85%;
  margin-bottom: 20px;
}

.place-name {
  transform: none !important;
  position: unset !important;
  margin-top: -4px !important;
  margin-left: 4px !important;
  font-size: 10px;
}

.button {
  padding: 0.5em;
  margin: 2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveryForm.vue